export class IstanzeProcedimentoVO {
  id: string;
  nome: string;
}
